export const GET_STUDENT_ADDRESS_SUCCESS = 'GET_STUDENT_ADDRESS_SUCCESS';
export const UPDATE_ADDRESS_SUCCESS = 'UPDATE_ADDRESS_SUCCESS';
export const UPDATE_ORDER_ADDRESS = 'UPDATE_ORDER_ADDRESS';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
